<div
  class="basic-layout"
  [class.left-side-invisible]="layout.leftMenuInvisible$ | async"
  [class.left-side-expand]="leftMenuState"
>
  <app-statistics-panel></app-statistics-panel>
  @if (themeClass === 'merry-christmas') {
    <div
      class="layout-widgets  {{ hideHead ? 'widgets-hide' : 'widgets-show' }}"
      [style.left]="layoutContentMarginLeft"
    >
      <img src="{{ 'assets/images/activity/christmas/c1.png' | preferWebp }}" alt="" />
      <img src="{{ 'assets/images/activity/christmas/c1.png' | preferWebp }}" alt="" />
    </div>
    <div class="layout-background">
      <img src="{{ 'assets/images/activity/christmas/bg.jpg' | preferWebp }}" alt="" />
    </div>
  }

  <div
    class="layout-backdrop"
    [class.show]="leftMenuBackdrop"
    [style.zIndex]="isH5 ? 7 : ''"
    (click)="layout.leftMenuState$.next(false)"
  ></div>

  @if (isH5) {
    <div
      class="left-side h5"
      [class.fullMode]="fullMode"
      [ngStyle]="{ transform: 'translateY(' + leftMenuTop + ')', width: leftMenuWidth }"
    >
      <app-left-menu></app-left-menu>
    </div>
  } @else {
    <div class="left-side" [ngStyle]="{ top: leftMenuTop, width: leftMenuWidth }">
      <app-left-menu></app-left-menu>
    </div>
  }

  <!-- <div [ngStyle]="{ width: leftMenuWidth }" [ngClass]="{ 'left-side': true, hide: conciseMode }">
    <app-left-menu></app-left-menu>
  </div> -->

  <div
    class="layout-content"
    [style.margin-left]="layoutContentMarginLeft"
    [class.chat-open]="isOpenSendbirdChat"
    [style.padding-top]="hideHead ? '0' : hideLevel2Head ? 'var(--topbar-height)' : '64px'"
    [style.padding-bottom]="(layout.h5BottomMenuVisible$ | async) && !fullMode ? '54px' : '0'"
  >
    <app-header
      [layoutContentMarginLeft]="layoutContentMarginLeft"
      [style.transition-duration]="hideHead ? '0.5s' : '0.2s'"
      [style.transform]="'translateY(' + (hideHead ? '-100' : '0') + '%)'"
    ></app-header>
    <!-- @if (hideLevel2Head) {
      <app-header-level2-menu
        #level2Menu
        [class.hide]="conciseMode"
        [layoutContentMarginLeft]="layoutContentMarginLeft"
        [style.transition-duration]="hideHead ? '0.5s' : '0.2s'"
        [style.transform]="'translateY(' + (hideHead ? '-250' : '0') + '%)'"
      ></app-header-level2-menu>
    } -->

    <div class="layout-main-content">
      <!-- 外殼負責 @defer；直接寫 <app-sendbird-chat> 會把整棵 layouts/sendbird-chat 綁進 initial bundle -->
      <app-sendbird-chat-panel></app-sendbird-chat-panel>
      <ng-container *ngIf="isDesktop">
        <app-scrollbar
          #scrollbar
          (scorllDistance)="onScrollDistance($event)"
          [disabled]="fullMode || !!(layout.lockLayoutScroll$ | async)"
        >
          <router-outlet></router-outlet>
          <app-footer *ngIf="!fullMode"></app-footer>
        </app-scrollbar>
      </ng-container>
      <div
        #mobileContent
        class="content"
        *ngIf="!isDesktop"
        [class.disabled]="fullMode || !!(layout.lockLayoutScroll$ | async)"
        (scroll)="onScrollOldIos($event)"
        [style.display]="isOpenSendbirdChat ? 'none' : 'block'"
      >
        <router-outlet></router-outlet>
        <app-footer *ngIf="!fullMode"></app-footer>
      </div>
      <app-bottom-menu *ngIf="!fullMode"></app-bottom-menu>
    </div>
  </div>
</div>
